/* eslint-disable react-hooks/exhaustive-deps */
// Library Imports
import { Fragment, useEffect, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { getPrivateRoutesForPermissions, publicRoutes } from "./config";
import PublicRoutes from "./PublicRoutes";
import PrivateRoutes from "./PrivateRoutes";
import ErrorPage from "../panel/ErrorPage";
import { PageLoader } from "../components/shared";
import { useSelector } from "react-redux";
import { useSocket } from "../redux/socket/useSocket.js";
import { preloadSecondaryPages } from "./secondaryPageLoaders";

const Router = () => {
  const user = useSelector((state) => state?.user?.user);
  const { sendCommand, isSocketReady } = useSocket();
  const privateRoutes = getPrivateRoutesForPermissions(user?.all_user_permissions || []);
  useEffect(() => {
    if (isSocketReady) {
      sendCommand("fetch_channels");
    }
  }, [isSocketReady]);
  useEffect(() => {
    const id = setTimeout(() => preloadSecondaryPages(), 2000);
    return () => clearTimeout(id);
  }, []);
  return (
    <Fragment>
      <Suspense fallback={<PageLoader />}>
        <Routes>
        {/* Private Routes */}
        <Route element={<PrivateRoutes />}>
          {privateRoutes?.map((route, index) =>
            route.child ? (
              <Route path={route.path} element={route.element} key={index}>
                {route.child.map((childRoute, index) => (
                  <Route
                    path={childRoute.path}
                    element={childRoute.element}
                    key={index}
                  />
                ))}
              </Route>
            ) : (
              <Route path={route.path} element={route.element} key={index} />
            ),
          )}
        </Route>

        {/* Public Routes */}
        <Route element={<PublicRoutes />}>
          {publicRoutes?.map((route, index) => (
            <Route path={route.path} element={route.element} key={index} />
          ))}
        </Route>

        {/* Not Found Route */}
        <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default Router;
